export const driverConstants = {
    BUSINESS_PARTNER_REQUEST: 'BUSINESS_PARTNER_REQUEST',
    BUSINESS_PARTNER_SUCCESS: 'BUSINESS_PARTNER_SUCCESS',
    BUSINESS_PARTNER_FAILURE: 'BUSINESS_PARTNER_FAILURE',

    BUSINESS_PARTNER: 'BUSINESS_PARTNER'
};